import React, { useState, useEffect } from 'react';
import Hero from '../Components/Hero/Hero';
import SearchBar from '../Components/SearchBar/SearchBar';
import Middle from '../Components/HomeMiddle/Middle';
import Footer from '../Components/Navigation/Footer';
import "../Pages/Home.css";
import Modal from '../Components/Modal';


function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Automatically open the modal when the page loads
  useEffect(() => {
    setIsModalOpen(true);
  }, []); // Empty dependency array means this effect runs only once when the component mounts

  const closeModal = () => setIsModalOpen(false);



  return (
    
    <div className='home'>
        <Hero />
        <SearchBar />
        <Middle />
        <Modal isOpen={isModalOpen} onClose={closeModal} />
        <Footer />
    </div>
  )
}

export default Home